/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ScopesControllerBulkDeleteMutationRequest, ScopesControllerBulkDeleteMutationResponse, ScopesControllerBulkDelete400, ScopesControllerBulkDelete401 } from "../../models/scopesController/ScopesControllerBulkDelete";

function getScopesControllerBulkDeleteUrl() {
  const res = { method: 'DELETE', url: `/api/v1/scopes/bulk` as const }  
  return res
}

/**
 * @description Delete multiple scopes (files/folders) in a single call. Folders are cascade-deleted with all descendants. If a folder and its nested items are both selected, nested items are deduplicated. Returns 200 if all items succeed, 207 Multi-Status if some items fail.
 * @summary Bulk delete scopes
 * {@link /api/v1/scopes/bulk}
 */
export async function scopesControllerBulkDelete(data: ScopesControllerBulkDeleteMutationRequest, config: Partial<RequestConfig<ScopesControllerBulkDeleteMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<ScopesControllerBulkDeleteMutationResponse, ResponseErrorConfig<ScopesControllerBulkDelete400 | ScopesControllerBulkDelete401>, ScopesControllerBulkDeleteMutationRequest>({ method : "DELETE", url : getScopesControllerBulkDeleteUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}